const useOfYourData = [
  {
    heading: 'Use of Your Data',
    paragraphs: [
      "We take data privacy very seriously and do not use or share your data or anything else you've given us with any third party companies.",
    ],
  },
]

export default useOfYourData
